import { StoreTemplate } from "@/templates/TemplateLoader";
import { ReactNode } from "react";
import ContactElement from "@/templates/black-and-white/elements/Contact";
import SectionContent from "@/templates/black-and-white/elements/SectionContent";
import PageHeader from "@/templates/black-and-white/elements/PageHeader";

const elements = {
  ContactElement,
  SectionContent,
  PageHeader,
};

export function ContactPagesLoader(props: { children: ReactNode }) {
  StoreTemplate.load("black-and-white", "contact", elements);
  return props.children;
}
